import { Timestamp } from 'firebase/firestore';
import { IMassUnit } from './massUnitType';
import { StatusType } from './statusType';
import { comment } from './FutureOrderType';

export interface Product {
  id: string;
  name: string;
  ingredients: IProductMaterialInfo[];
  category: string;
  subCategory: string;
  filesUrl: string[];
  comments?: comment[];
  measureType: MeasureType;
  status: StatusType;
  updatedAt: Timestamp;
  uuid?: string;
  accountId?: string;
  priceHistory?: { price: number; date: Date }[];
  unitWeight?: number;
  currentPrice?: number;
  dismissAt?: Timestamp;
}

export interface IProductCategory {
  name: string;
  subCategories: string[];
}

export type MeasureType = 'Unit' | 'Meter' | 'Ton';
export const ProductMeasureTypes: MeasureType[] = ['Unit', 'Meter', 'Ton'];

export interface IProductMaterialInfo {
  materialID: string;
  weightInProduct: number;
  massUnit?: IMassUnit; // Saved Mass Unit on DB should always be metricTon
  percentInProduct?: number;
}

export const getProductNameById = (id: string, productList: Product[]) => {
  return productList.find((item) => item.uuid === id)?.name || id;
};

export function convertProductsToRecord(products: Product[]): Record<string, Product> {
  return products.reduce((acc, product) => {
    acc[product.uuid || 0] = product;
    return acc;
  }, {} as Record<string, Product>);
}

export const mockProductCategories: IProductCategory[] = [
  {
    name: 'Electricity',
    subCategories: ['Solar panel'],
  },
  {
    name: 'Building',
    subCategories: ['Industrial'],
  },
  {
    name: 'Mechanics',
    subCategories: ['Aircraft'],
  },
  {
    name: 'Plumbing',
    subCategories: ['Pipes', 'Fittings'],
  },
  {
    name: 'HVAC',
    subCategories: ['Heating', 'Ventilation', 'Air Conditioning'],
  },
  {
    name: 'Electronics',
    subCategories: ['Circuit Boards', 'Sensors'],
  },
  {
    name: 'Automotive',
    subCategories: ['Engine Parts', 'Body Parts'],
  },
  {
    name: 'Furniture',
    subCategories: ['Chairs', 'Tables', 'Cabinets'],
  },
  {
    name: 'Textiles',
    subCategories: ['Fabrics', 'Yarns'],
  },
  {
    name: 'Agriculture',
    subCategories: ['Machinery', 'Fertilizers'],
  },
  {
    name: 'Chemicals',
    subCategories: ['Cleaning Agents', 'Solvents'],
  },
  {
    name: 'Metallurgy',
    subCategories: ['Steel', 'Aluminum'],
  },
  {
    name: 'Mining',
    subCategories: ['Coal', 'Ore'],
  },
  {
    name: 'Food & Beverage',
    subCategories: ['Ingredients', 'Packaging'],
  },
  {
    name: 'Pharmaceuticals',
    subCategories: ['Medicines', 'Supplements'],
  },
  {
    name: 'Cosmetics',
    subCategories: ['Skincare', 'Makeup'],
  },
  {
    name: 'Construction',
    subCategories: ['Cement', 'Bricks'],
  },
  {
    name: 'Printing',
    subCategories: ['Ink', 'Paper'],
  },
  {
    name: 'Woodworking',
    subCategories: ['Lumber', 'Plywood'],
  },
  {
    name: 'Glass',
    subCategories: ['Windows', 'Bottles'],
  },
  {
    name: 'Packaging',
    subCategories: ['Plastic', 'Cardboard'],
  },
  {
    name: 'Recycling',
    subCategories: ['Plastic', 'Metal'],
  },
  {
    name: 'Rubber',
    subCategories: ['Tires', 'Seals'],
  },
];
